import { ReactElement } from 'react';
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Icon, IconTypes } from '../../../../../components/Icon';
import { Option } from '../../../../../components/MuiSingleSelect/MuiSingleSelect';
import { colors } from '../../../../../theme/colors';

const Container = styled('div')`
  display: flex;
  background-color: ${({ theme }) => theme.colors.neutral[5]};
  border-radius: 4px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
`;

interface Props {
  column: Option;
  locked?: boolean;
}

export const ColumnItemDropdownToggler = ({ column, locked = false }: Props): ReactElement => {
  return (
    <Container>
      <Typography variant='body2' color={locked ? 'text.secondary' : 'text.primary'}>
        {column.value}
      </Typography>
      {!locked && <Icon type={IconTypes.ARROW_DOWN} color={colors.neutral[60]} />}
    </Container>
  );
};
